module.exports = __webpack_public_path__ + "img/ico18.c1e3487d.svg";